export enum RoutesViewMode {
  CARDS = 'CARDS',
  TABLE = 'TABLE'
}
